import $ from 'jquery';
import React from 'react';
import { useEffect } from 'react';


const Slide = () =>{
    let curPos= 0;
    let curArrow =0;

    // 렌더링이 되고, 한번 실행되게 useEffect사용.(인터벌 함수 1번.)
    // useEffect 사용하지 않으면, 렌더링 전, 렌더링 후에 실행되서 2번씩 실행됨.
    useEffect(() => {
       const interval = setInterval(switching,11000);

       return () => clearInterval(interval);
    }, []);

    //스트릭모드 해제시 1줄
    //setInterval(switching,11000);

    function switching(){
        switch(curPos){
            case 0 :
                $(".item1").stop().toggleClass('active2');
                $(".tp-caption").stop().toggleClass('active3');
                $(".tp-caption2").stop().toggleClass('active4'); 
                $(".tp-caption").stop().toggleClass('active5');
                $(".tp-caption2").stop().toggleClass('active5'); 
                curPos += 1;
                break;
            case 1 :
                $(".item1").stop().toggleClass('active2');
                $(".tp-caption").stop().toggleClass('active3');
                $(".tp-caption2").stop().toggleClass('active4');
                $(".tp-caption").stop().toggleClass('active5');
                $(".tp-caption2").stop().toggleClass('active5'); 
                curPos -=1;
                break;
            default:
            }
        }

    function arrowH(){
        switch(curArrow){
            case 0 :
                $(".arrow").css('transition-delay','0s');
                $(".arrow").css('opacity','1');
                curArrow += 1;
                break;
            case 1 :
                $(".arrow").css('transition-delay','0.6s');
                $(".arrow").css('opacity','0');
                curArrow -=1;
                break;
            default:
            }
    }


    return(
        
        <>
            <div className='main-slider'>
                <div style={{position:'relative',width:'100%',height:'auto',marginTop:'0px',marginBottom:'0px'}}>
                    <div  className='tp-banner-container'>
                        <div className='tp-banner' onMouseOver={arrowH} onMouseOut={arrowH}>
                            <button className='prev arrow' onClick={switching}>〈</button>
                            <button className='next arrow' onClick={switching}>〉</button>
                            <ul className='sliderItemsUl'>
                                <li className='sliderItems'>
                                    <img className='item2' src="images/main-slider/2.jpg"  alt="" />
                                    <img className='item1 active2' src="images/main-slider/1.jpg"  alt="" />
                                    <img className='item3' src="images/main-slider/1.jpg"  alt="" />
                                </li>
                                <li className='sliderItems2'>
                                    <div className="tp-caption sft sfb tp-resizeme active5"><div className="text-left" style={{marginBottom:'30px'}}><h2>"가치경영, 고객만족, 행복경영" <br/> 최고의 IoT 기술 전문 기업을 추구합니다.</h2></div></div>
                                    <div className="tp-caption2 sft sfb tp-resizeme active5"><div className="text">고객의 다양한 Needs와 기술력과 특화된 솔루션으로 고객만족에 힘쓰겠습니다.</div></div>
                                </li>
                                <li className='sliderItems2'>
                                    <div className="tp-caption sft sfb tp-resizeme  active3"><div className="text-left" style={{marginBottom:'30px'}}><h2>IoT 기술의 가치 <br/> 넥스모어가 만들어 갑니다.</h2></div></div>
                                    <div className="tp-caption2 sft sfb tp-resizeme  active4"><div className="text">끊임없이 변화하는 넥스모어는 더 나은 세상을 만들어 갑니다.</div></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Slide;